// extracted by mini-css-extract-plugin
export var content = "_mk-1";
export var divider = "_mk-0";